module.exports = {"closeButtonText":"Schließen","thumbNailAlt":"Vorschau des Bilds anzeigen","next":"Nächste Seite","previous":"Vorherige Seite","addNote":"Eine Notiz hinzufügen..."}


//////////////////
// WEBPACK FOOTER
// ./translations/de.json
// module id = 24
// module chunks = 0